<main class="mx-0">
  <router-outlet />
</main>